import type { Dayjs } from 'dayjs';
import {
  formatVnCalendarDate,
  formatVnDate,
  formatVnDateTime,
} from './vnDateTime';

/** Format points with thousand separators (e.g. 1,234 điểm) */
export function formatPoints(points: number): string {
  return `${new Intl.NumberFormat('vi-VN').format(points)} điểm`;
}

/** Format date range for display (e.g. 01/01/2024 – 31/01/2024) */
export function formatDateRange(
  start: string | Dayjs | null | undefined,
  end: string | Dayjs | null | undefined
): string {
  const startStr = start ? formatVnDate(start) : '—';
  const endStr = end ? formatVnDate(end) : '—';
  if (startStr === '—' && endStr === '—') return '–';
  return `${startStr === '—' ? '?' : startStr} → ${
    endStr === '—' ? '?' : endStr
  }`;
}

/** Format single date (DD/MM/YYYY HH:mm) */
export function formatDateTime(dateStr: string | null | undefined): string {
  if (!dateStr) return '–';
  const formatted = formatVnDateTime(dateStr);
  return formatted === '—' ? '–' : formatted;
}

/** Format short date (DD/MM) */
export function formatDateShort(dateStr: string | null | undefined): string {
  if (!dateStr) return '–';
  const formatted = formatVnCalendarDate(dateStr, 'DD/MM');
  return formatted === '—' ? '–' : formatted;
}

export type CampaignStatus = 'DRAFT' | 'ACTIVE' | 'PAUSED' | 'ENDED';
export type CampaignType = 'SHOP' | 'ITEM';

export const STATUS_LABELS: Record<CampaignStatus, string> = {
  DRAFT: 'Nháp',
  ACTIVE: 'Đang chạy',
  PAUSED: 'Tạm dừng',
  ENDED: 'Đã kết thúc',
};

export const TYPE_LABELS: Record<CampaignType, string> = {
  SHOP: 'TOÀN SHOP',
  ITEM: 'MÓN ĂN',
};

export function statusLabel(status: string): string {
  return STATUS_LABELS[status as CampaignStatus] ?? status;
}

export function typeLabel(type: string): string {
  return TYPE_LABELS[type as CampaignType] ?? type;
}

export const STATUS_COLORS: Record<CampaignStatus, string> = {
  DRAFT: 'default',
  ACTIVE: 'green',
  PAUSED: 'orange',
  ENDED: 'default',
};

export const TYPE_COLORS: Record<CampaignType, string> = {
  SHOP: 'blue',
  ITEM: 'purple',
};
